import React from 'react';
import FinanceFormCreate from './FinanceFormCreate';
import FinanceFormEdit from './FinanceFormEdit';

/**
 * 财务记录表单包装组件（向后兼容）
 * @deprecated 请直接使用 FinanceFormCreate 或 FinanceFormEdit
 * 
 * 此组件保留用于向后兼容，新代码应该：
 * - 新增记录：使用 FinanceFormCreate
 * - 编辑记录：使用 FinanceFormEdit
 */
const FinanceFormView = ({ editMode = false, initialData = {}, isSaving = false, onBack, onSave, onDelete }) => {
  // 根据 editMode 渲染对应的专用组件
  if (editMode) {
    return (
      <FinanceFormEdit
        initialData={initialData}
        isSaving={isSaving}
        onBack={onBack}
        onSave={onSave}
        onDelete={onDelete}
      />
    );
  }

  return (
    <FinanceFormCreate
      isSaving={isSaving}
      onBack={onBack}
      onSave={onSave}
    />
  );
};

export default FinanceFormView;
